!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {
    const $slides = $('.slide');
    let currentIndex = 0;
    const totalSlides = $slides.length;
    const slideIntervalTime = 3000; // Time between slides in milliseconds (3 seconds)
    let slideInterval;
    let isHovered = false;

    function startSlider() {
      stopSlider(); // Clear any existing interval before starting a new one
      slideInterval = setInterval(() => {
        if (!isHovered) {
          showSlide(currentIndex + 1);
        }
      }, slideIntervalTime);
    }

    function stopSlider() {
      clearInterval(slideInterval);
    }

    function showSlide(index) {
      if (index >= totalSlides) {
        currentIndex = 0;
      } else if (index < 0) {
        currentIndex = totalSlides - 1;
      } else {
        currentIndex = index;
      }
      $('.slides').css({
        'transform': `translateX(-${currentIndex * 100}%)`,
        'transition': 'transform 0.5s ease-in-out'
      });
    }

    function showNextSlide() {
      showSlide(currentIndex + 1);
    }

    function showPrevSlide() {
      showSlide(currentIndex - 1);
    }

    // Auto-slide
    startSlider();

    // Navigation buttons
    $('.next').on('click', function() {
      stopSlider(); // Stop the auto-slide to avoid creating multiple intervals
      showNextSlide();
      startSlider(); // Restart the auto-slide after the manual change
    });

    $('.prev').on('click', function() {
      stopSlider(); // Stop the auto-slide to avoid creating multiple intervals
      showPrevSlide();
      startSlider(); // Restart the auto-slide after the manual change
    });

    // Pause on hover
    $('.image-slider').hover(
      function() { // Mouse enter
        isHovered = true;
        stopSlider(); // Stop auto-slide when hovering
      },
      function() { // Mouse leave
        isHovered = false;
        startSlider(); // Restart auto-slide when mouse leaves
      }
    );
  });

}(jQuery);